import { useRef, useEffect, useState } from "react";
import Accordion from "../../../../../components/Accordion/Accordion";
import { ApplicationInformationData } from "./data/ApplicationInformationData";
import { useParams } from "react-router-dom";
import { decryptAESID } from "../../../../../utils/Encryption";
import FormCreator from "../../../../../components/Forms/FormCreator";
import { setFieldParameter } from "./utils/setFieldParameter";
import { setAllDropDownField,setmainContactFields } from "./utils/dropdownUtils"
import { setProductDetailsDropDown } from "./utils/dropdownUtils";
import { useLazyGetProductApplicationInformationIdQuery } from "../../../../../app/services/selfEvalutionReviewService/selfEvalutionReviewServiceApi";
import { useGetAllDropdownForSubCategoryByL1Mutation, useGetAllDropdownForTypeByL2Mutation } from "../../../../../app/services/Crud/crudApi";
import { useLazyGetDropDownsForProductsAndServicesQuery,useLazyGetMainContactPersonDropdownByCorporateMemberIdQuery } from "../../../../../app/services/productAndService/productAndServiceApi";


const ApplicationInformation = () => {
  const { id } = useParams();
  const editID = id ? decryptAESID(id, false) : 0;
  const MemberApplicationRef = useRef();
  const [formData, setFormData] = useState(ApplicationInformationData);


  const [getProductApplicationInformationId, { data: productApplicationData, isLoading: productApplicationLoading, isFetching: productApplicationIsFeteching, }] = useLazyGetProductApplicationInformationIdQuery()
  const [subCategoryByL1Dropdown, { data: subCategoryByL1DropdownData, isLoading: subCategoryByL1DropdownLoading, },] = useGetAllDropdownForSubCategoryByL1Mutation();
  const [typeByL2Dropdown, { data: typeByL2DropdownData, isLoading: typeByL2DropdownLoading, },] = useGetAllDropdownForTypeByL2Mutation();
  const [mainContactPersonDropdown, { data: mainContactPersonDropdownData, isLoading: mainContactPersonDropdownLoading, },] = useLazyGetMainContactPersonDropdownByCorporateMemberIdQuery();
  const [productsAndServicesDropdown, { data: productsAndServicesDropDownsData, isLoading: productsAndServicesDropDownsLoading, },] = useLazyGetDropDownsForProductsAndServicesQuery();



  useEffect(() => {
    productsAndServicesDropdown()
    if (editID > 0) {
      getProductApplicationInformationId(editID);
    }
  }, [editID])

  useEffect(() => {
    if (!productApplicationLoading && productApplicationData) {      
      const extension = productApplicationData?.productCateloueFileName?.split('.').pop().toLowerCase();
      handleCallL2andL3type(productApplicationData);
      let updatedFormData = { ...formData, formFields: formData?.formFields?.map(field => field.id === "productCateloueName" ? { ...field, fieldSetting: { ...field.fieldSetting, isDownloadable: extension == "pdf" ? true : false, viewImage: extension == "pdf" ? false : true, }, } : field), };
      setFieldParameter(productApplicationData);
      setFormData(updatedFormData);
      mainContactPersonDropdown(productApplicationData?.sgbcCorporateMemberId);
    }
  }, [productApplicationLoading, productApplicationData]);

  useEffect(() => {
    if (!productsAndServicesDropDownsLoading && productsAndServicesDropDownsData) {
      setAllDropDownField(productsAndServicesDropDownsData, setFormData);
    }
  }, [productsAndServicesDropDownsLoading, productsAndServicesDropDownsData]);

    useEffect(() => {
      if (!mainContactPersonDropdownLoading && mainContactPersonDropdownData) {
        setmainContactFields(mainContactPersonDropdownData, setFormData);
      }
    }, [mainContactPersonDropdownLoading, mainContactPersonDropdownData]);



  const handleCallL2andL3type = async (taskDetailsData) => {
    let { categoryL1Id, subCategoryL2Id } = taskDetailsData;
    const apiResponseL2 = await subCategoryByL1Dropdown({ CategoryL1Id: categoryL1Id });
    const filterDropdownL2 = apiResponseL2?.data?.map((item) => ({ ...item, dropdownName: "categoryKey" }));
    const apiResponseL3 = await typeByL2Dropdown({ SubCategoryL2Id: subCategoryL2Id });
    const filterDropdownL3 = apiResponseL3?.data?.map((item) => ({ ...item, dropdownName: "subCategoryKey" }));
    let data = [...filterDropdownL2, ...filterDropdownL3]
    setProductDetailsDropDown(data, "categoryKey", "subCategoryKey");
  }


  return (
      <div className="application-information">
        <Accordion
          title="Application Information"
          className="mb-4"
          button={false}
          accordion={true}
        >
          <div className="row">
            <FormCreator
              ref={MemberApplicationRef}
              {...formData}
            />
          </div>
        </Accordion>
      </div>

  );
};

export default ApplicationInformation;
